<router-outlet>
  <loading *ngIf="isLoading | async"></loading>
</router-outlet>
